// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "nav-bar-module--base-text-alt--global--a2d35";
export var baseTextGlobal = "nav-bar-module--base-text--global--d8ac5";
export var blockSpacing100 = "nav-bar-module--block-spacing-100--2239c";
export var blockSpacing50 = "nav-bar-module--block-spacing-50--de2c8";
export var blockVPadding100 = "nav-bar-module--block-v-padding-100--cb1e0";
export var blockVPadding50 = "nav-bar-module--block-v-padding-50--7eb1a";
export var captionTextGlobal = "nav-bar-module--caption-text--global--fce01";
export var cmsRenderedContentGlobal = "nav-bar-module--cms-rendered-content--global--c74b8";
export var container = "nav-bar-module--container--23776";
export var containerTop = "nav-bar-module--containerTop--91918";
export var defaultHSpacingGlobal = "nav-bar-module--default-h-spacing--global--b63d1";
export var desktopNavBar = "nav-bar-module--desktopNavBar--05352";
export var fadeInAnimation = "nav-bar-module--fadeInAnimation--b8803";
export var fadeInOnLoadGlobal = "nav-bar-module--fade-in-on-load--global--47be6";
export var fullHeightGlobal = "nav-bar-module--full-height--global--6c8d2";
export var fullHeightOmittingNavGlobal = "nav-bar-module--full-height-omitting-nav--global--7875b";
export var headingTextGlobal = "nav-bar-module--heading-text--global--cc3e7";
export var ingressTextGlobal = "nav-bar-module--ingress-text--global--f3f4f";
export var linkColorChangeTransitionGlobal = "nav-bar-module--link-color-change-transition--global--74b7d";
export var mobileNavBar = "nav-bar-module--mobileNavBar--d80d2";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "nav-bar-module--page-heading-text--global--ff75d";
export var paragraphTextGlobal = "nav-bar-module--paragraph-text--global--c4c1e";
export var subheadingTextGlobal = "nav-bar-module--subheading-text--global--9c222";